import { GridColDef } from "@mui/x-data-grid-pro";
import { IconButton } from "@mui/material";
import DynamicIcon from "../../../../../../components/global/DynamicIcon";
import LargeItemStatus from "../../../../../../common/components/large_item_status";

type Props = {
  onActionEditar: (id: number | null, openState: boolean) => void;
};

export const GenerateProjetoRevisaoColumnDefinition = ({
  onActionEditar,

}: Props): GridColDef[] => {
  const computeStatusDescription = (status: number) => {
    switch (status) {
      case 0:
        return "Aberta";
      case 1:
        return "Em Análise";
      case 2:
        return "Encerrada";
      default:
        return "Desconhecido";
    }
  };

  const computeStatusColor = (status: number) => {
    switch (status) {
      case 0:
        return "red";
      case 1:
        return "yellow";
      case 2:
        return "green";
      default:
        return "gray";
    }
  };

  return [
    {
      field: "status",
      headerName: "Status",
      flex: 1,
      minWidth: 150,
      sortable: false,
      filterable: false,
      renderCell: (params) => (
        <div className="w-full h-full flex justify-center items-center">
          <LargeItemStatus title={computeStatusDescription(params.value)} color={computeStatusColor(params.value)} description="" />
        </div>
      ),
    },
    {
      field: "projeto",
      headerName: "Projeto",
      flex: 1,
      minWidth: 200,
      sortable: false,
      filterable: false,
    },
    {
      field: "centroCusto",
      headerName: "Centro de Custo",
      flex: 1,
      minWidth: 180,
      sortable: false,
      filterable: false,
    },
    {
      field: "dataSolicitacao",
      headerName: "Data Solicitação",
      flex: 1,
      minWidth: 160,
      sortable: false,
      filterable: false,
      valueGetter: (params) => (params ? new Date(params).toLocaleDateString("pt-BR", { timeZone: "UTC" }) : ""),
    },
    {
      field: "solicitante",
      headerName: "Solicitante",
      flex: 1,
      minWidth: 200,
      sortable: false,
      filterable: false,
    },
    {
      field: "dataAprovacao",
      headerName: "Data Início",
      flex: 1,
      minWidth: 200,
      sortable: false,
      filterable: false,
      valueGetter: (params) => (params ? new Date(params).toLocaleDateString("pt-BR", { timeZone: "UTC" }) : ""),
    },
    {
      field: "dataTermino",
      headerName: "Data Término",
      flex: 1,
      minWidth: 200,
      sortable: false,
      filterable: false,
      valueGetter: (params) => (params ? new Date(params).toLocaleDateString("pt-BR", { timeZone: "UTC" }) : ""),
    },
    {
      field: "aprovador",
      headerName: "Responsável Análise",
      flex: 1,
      minWidth: 220,
      sortable: false,
      filterable: false,
    },
    {
      field: "idProjetoRevisao",
      headerName: "Editar",
      width: 120,
      sortable: false,
      filterable: false,
      renderCell: (params) => (
        <div className="flex items-center justify-center w-full h-full gap-2">
          <IconButton onClick={() => onActionEditar(params.row.idProjetoRevisao, true)}>
            <DynamicIcon nameIcon="EditRounded" size={25} className="dark:text-white text-primary-green" />
          </IconButton>
        </div>
      ),
    },
  ];
};
